/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Next_MarkerInputs */



/**
* | output |
* | --- |
* | "Next Marker" |
*
* @param {Shortcut_Keys_Name_Next_MarkerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_next_marker = /** @type {((inputs?: Shortcut_Keys_Name_Next_MarkerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Next_MarkerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marqueur suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nächster Marker")
	if (locale === "it") return /** @type {LocalizedString} */ ("Marcatore successivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Следующий маркер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Siguiente marcador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下一个标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次のマーカー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगला मार्कर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Próximo marcador")
	return /** @type {LocalizedString} */ ("Next Marker")
});